import type { BlogPost } from '@rumblefish/strapi/strapiTypes';
import type { GetStaticPaths, GetStaticProps } from 'next';
import { fetchBlogPosts } from '../../../utils/api/fetchStrapiData';
import { BlogPage } from '../../../views/blogPage';

import { normalizeCategoryName } from '../../../views/blogPage/BlogPage.utils';

const getCategories = (blogPosts: BlogPost[]) => {
  return blogPosts.reduce<string[]>((acc, post) => {
    if (post.category) {
      post.category.forEach((category) => {
        const categoryName = category?.name?.trim();

        if (categoryName && !acc.includes(categoryName)) {
          acc.push(categoryName);
        }
      });
    }
    return acc;
  }, []);
};

export const getStaticProps: GetStaticProps = async () => {
  const blogPosts: BlogPost[] = await fetchBlogPosts();

  const categories = getCategories(blogPosts);

  return {
    props: { blogPosts, categories },
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  const blogPosts: BlogPost[] = await fetchBlogPosts();

  const categories = getCategories(blogPosts);

  const paths = categories.map((category) => ({
    params: { slug: normalizeCategoryName(category) },
  }));

  return {
    fallback: false,
    paths: paths,
  };
};

export default BlogPage;
